// AirDrive — scripts propios (prefijo ad-)
document.addEventListener('DOMContentLoaded', function () {
  initRevelado();
  initContadores();
  initGaleriaProducto();
  initVariantesProducto();
  initInclinacion();
  initParalaje();
  initMarquesina();
  initComparador();
  initBarraFlotanteCarrito();
  initCarruseles();
});

// Reveals al hacer scroll (IntersectionObserver compartido)
function initRevelado() {
  var els = document.querySelectorAll('.ad-reveal, .ad-reveal-stagger');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('ad-visible'); });
    return;
  }
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('ad-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
  );
  els.forEach(function (el) { observer.observe(el); });
}

// Cifras animadas (count-up) al entrar en pantalla
function initContadores() {
  var els = document.querySelectorAll('.ad-count-up');
  if (!els.length || !('IntersectionObserver' in window)) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        observer.unobserve(el);
        var fin = parseFloat(el.dataset.valor || el.textContent) || 0;
        if (reduce) { el.textContent = el.dataset.valor || el.textContent; return; }
        var duracion = 1200;
        var inicio = null;
        function paso(ts) {
          if (!inicio) inicio = ts;
          var progreso = Math.min((ts - inicio) / duracion, 1);
          var actual = fin * (1 - Math.pow(1 - progreso, 3));
          el.textContent = (el.dataset.decimales === '1') ? actual.toFixed(1) : Math.round(actual);
          if (progreso < 1) requestAnimationFrame(paso);
          else el.textContent = el.dataset.valor;
        }
        requestAnimationFrame(paso);
      });
    },
    { threshold: 0.4 }
  );
  els.forEach(function (el) { observer.observe(el); });
}

// Galería de la página de producto: cambia la imagen principal al pulsar una miniatura
function initGaleriaProducto() {
  var galeria = document.querySelector('[data-ad-galeria]');
  if (!galeria) return;
  var caja = galeria.querySelector('[data-ad-imagen-principal-caja]');
  var minis = galeria.querySelectorAll('[data-ad-miniatura]');
  if (!caja || !minis.length) return;
  var estiloMedia = 'width:100%;height:100%;object-fit:contain;display:block;';
  minis.forEach(function (mini) {
    mini.addEventListener('click', function () {
      var src = mini.dataset.full;
      if (!src) return;
      if (mini.dataset.tipo === 'video') {
        var fuentes = src.split('|');
        var mimes = (mini.dataset.mime || '').split('|');
        var video = document.createElement('video');
        video.setAttribute('data-ad-imagen-principal', '');
        video.autoplay = true;
        video.muted = true;
        video.loop = true;
        video.playsInline = true;
        video.preload = 'auto';
        video.style.cssText = estiloMedia;
        fuentes.forEach(function (url, i) {
          if (!url) return;
          var source = document.createElement('source');
          source.src = url;
          if (mimes[i]) source.type = mimes[i];
          video.appendChild(source);
        });
        caja.innerHTML = '';
        caja.appendChild(video);
      } else {
        var img = document.createElement('img');
        img.setAttribute('data-ad-imagen-principal', '');
        img.src = src;
        img.alt = mini.dataset.alt || '';
        img.style.cssText = estiloMedia;
        caja.innerHTML = '';
        caja.appendChild(img);
      }
      minis.forEach(function (m) { m.classList.remove('ad-miniatura-activa'); });
      mini.classList.add('ad-miniatura-activa');
    });
  });
}

// Selector de variantes en la página de producto: actualiza precio, id y disponibilidad
function initVariantesProducto() {
  var wrap = document.querySelector('[data-ad-variantes]');
  if (!wrap) return;
  var datosEl = document.querySelector('[data-ad-variantes-json]');
  if (!datosEl) return;
  var variantes;
  try { variantes = JSON.parse(datosEl.textContent); } catch (e) { return; }

  var inputs = wrap.querySelectorAll('input[type="radio"]');
  var idInput = document.querySelector('[data-ad-variant-id]');
  var precioEl = document.querySelector('[data-ad-precio]');
  var precioComparado = document.querySelector('[data-ad-precio-comparado]');
  var botonComprar = document.querySelector('[data-ad-boton-comprar]');

  function opcionesSeleccionadas() {
    var seleccion = [];
    wrap.querySelectorAll('[data-ad-opcion]').forEach(function (grupo) {
      var marcado = grupo.querySelector('input:checked');
      if (marcado) seleccion.push(marcado.value);
    });
    return seleccion;
  }

  function actualizar() {
    var seleccion = opcionesSeleccionadas();
    var variante = variantes.find(function (v) {
      return v.options.length === seleccion.length && v.options.every(function (opt, i) { return opt === seleccion[i]; });
    });
    if (!variante) return;
    if (idInput) idInput.value = variante.id;
    if (precioEl) precioEl.textContent = variante.price_formatted;
    var precioStickyEl = document.querySelector('[data-ad-precio-sticky]');
    if (precioStickyEl) precioStickyEl.textContent = variante.price_formatted;
    if (precioComparado) {
      if (variante.compare_at_price_formatted) {
        precioComparado.textContent = variante.compare_at_price_formatted;
        precioComparado.style.display = '';
      } else {
        precioComparado.style.display = 'none';
      }
    }
    if (botonComprar) {
      botonComprar.disabled = !variante.available;
      var botonComprarSpan = botonComprar.querySelector('span');
      var botonComprarTexto = variante.available ? botonComprar.dataset.textoDisponible : botonComprar.dataset.textoAgotado;
      if (botonComprarSpan) botonComprarSpan.textContent = botonComprarTexto; else botonComprar.textContent = botonComprarTexto;
    }
  }

  inputs.forEach(function (input) { input.addEventListener('change', actualizar); });
  actualizar();
}

// Tarjetas con inclinación 3D suave al pasar el ratón (desktop, sin tocar en móvil)
function initInclinacion() {
  var tarjetas = document.querySelectorAll('[data-ad-tilt]');
  if (!tarjetas.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (window.matchMedia('(hover: none)').matches) return;

  tarjetas.forEach(function (tarjeta) {
    tarjeta.style.transformStyle = 'preserve-3d';
    tarjeta.style.willChange = 'transform';
    tarjeta.addEventListener('mousemove', function (e) {
      var r = tarjeta.getBoundingClientRect();
      var x = (e.clientX - r.left) / r.width - 0.5;
      var y = (e.clientY - r.top) / r.height - 0.5;
      tarjeta.style.transform = 'perspective(700px) rotateX(' + (y * -7) + 'deg) rotateY(' + (x * 7) + 'deg) translateY(-4px)';
    });
    tarjeta.addEventListener('mouseleave', function () {
      tarjeta.style.transform = '';
    });
  });
}

// Paralaje suave (transform en scroll, nunca background-attachment)
function initParalaje() {
  var els = document.querySelectorAll('[data-ad-parallax]');
  if (!els.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var ticking = false;
  function actualizar() {
    var vh = window.innerHeight;
    els.forEach(function (el) {
      var r = el.getBoundingClientRect();
      var centro = r.top + r.height / 2;
      var progreso = (vh / 2 - centro) / vh;
      var intensidad = parseFloat(el.dataset.adParallax) || 24;
      el.style.transform = 'translateY(' + (progreso * intensidad) + 'px)';
    });
    ticking = false;
  }
  window.addEventListener('scroll', function () {
    if (!ticking) { requestAnimationFrame(actualizar); ticking = true; }
  }, { passive: true });
  actualizar();
}

// Comparador antes/después con deslizador arrastrable
function initComparador() {
  var comparadores = document.querySelectorAll('[data-ad-comparador]');
  comparadores.forEach(function (contenedor) {
    var posInicial = parseFloat(contenedor.dataset.adComparador) || 50;
    contenedor.style.setProperty('--ad-pos', posInicial + '%');

    function fijar(clientX) {
      var r = contenedor.getBoundingClientRect();
      var pct = ((clientX - r.left) / r.width) * 100;
      pct = Math.max(0, Math.min(100, pct));
      contenedor.style.setProperty('--ad-pos', pct + '%');
    }

    var arrastrando = false;
    contenedor.addEventListener('pointerdown', function (e) {
      arrastrando = true;
      contenedor.setPointerCapture(e.pointerId);
      fijar(e.clientX);
    });
    contenedor.addEventListener('pointermove', function (e) {
      if (!arrastrando) return;
      fijar(e.clientX);
    });
    ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (ev) {
      contenedor.addEventListener(ev, function () { arrastrando = false; });
    });
  });
}

// Barra flotante de "Añadir al carrito": aparece al bajar la página, una vez
// el botón real de compra sale de la pantalla por arriba.
function initBarraFlotanteCarrito() {
  var barra = document.querySelector('[data-ad-sticky-carrito]');
  var botonReal = document.querySelector('[data-ad-boton-comprar]');
  var botonSticky = document.querySelector('[data-ad-boton-sticky]');
  if (!barra || !botonReal || !botonSticky) return;

  botonSticky.addEventListener('click', function () {
    botonReal.click();
  });

  if (!('IntersectionObserver' in window)) return;
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          barra.classList.remove('ad-sticky-visible');
        } else if (entry.boundingClientRect.top < 0) {
          barra.classList.add('ad-sticky-visible');
        } else {
          barra.classList.remove('ad-sticky-visible');
        }
      });
    },
    { threshold: 0 }
  );
  observer.observe(botonReal);
}

// Carrusel deslizable genérico (confianza, citas/poemas...): desliza con el
// dedo o el ratón, y los puntos de abajo llevan a cada tarjeta y se marcan
// solos al deslizar. Cada bloque de tipo [data-ad-carrusel] se inicializa por
// separado, así puede haber varios carruseles distintos en la misma página.
function initCarruseles() {
  var carruseles = document.querySelectorAll('[data-ad-carrusel]');
  carruseles.forEach(function (carrusel) {
    var pista = carrusel.querySelector('[data-ad-carrusel-pista]');
    var slides = carrusel.querySelectorAll('[data-ad-carrusel-slide]');
    var puntos = carrusel.querySelectorAll('[data-ad-carrusel-punto]');
    if (!pista || !slides.length || !puntos.length) return;

    puntos.forEach(function (punto, indice) {
      punto.addEventListener('click', function () {
        var slide = slides[indice];
        if (!slide) return;
        pista.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      });
    });

    var frameProgramado = false;
    pista.addEventListener('scroll', function () {
      if (frameProgramado) return;
      frameProgramado = true;
      requestAnimationFrame(function () {
        frameProgramado = false;
        var indiceActual = Math.round(pista.scrollLeft / pista.clientWidth);
        puntos.forEach(function (punto, indice) {
          punto.classList.toggle('ad-activo', indice === indiceActual);
        });
      });
    });
  });
}

// Marquesina infinita (logos/palabras) con contenido duplicado y animación CSS
function initMarquesina() {
  var pistas = document.querySelectorAll('[data-ad-marquesina]');
  pistas.forEach(function (pista) {
    if (pista.dataset.adDuplicado) return;
    pista.innerHTML += pista.innerHTML;
    pista.dataset.adDuplicado = '1';
  });
}
